import styled from 'styled-components';
import closeIcon from 'assets/img/close-icon.svg';
import {
  Modal, ModalHeader, ModalFooter, ModalBody,
} from 'reactstrap';
import { colors, fonts } from 'stylesheets';

export const DeleteModal = styled(Modal)`
  width: 605px;
  height: 206px;
  max-width: none;
  margin-top: 250px;
`;

export const Header = styled(ModalHeader)`
  border-bottom: 0px solid ${colors.greyLighter};
  height: 55px;
  h5 {
    font: 16px ${fonts.secondary};
    text-transform: uppercase;
    font-weight: 500;
    text-align: center;
    display: block;
    width: 100%;
  }
  button {
    position: absolute;
    right: 20px;
    top: 20px;
    background: url(${closeIcon}) no-repeat center;
    &:active,
    &:focus {
      outline: none;
      border: none;
    }
    span {
      display: none;
    }
  }
`;

export const Body = styled(ModalBody)`
  padding: 30px 110px;
  p {
    font: 14px ${fonts.secondary};
    color: ${colors.greyDark}
    text-align: center;
  }
`;

export const Footer = styled(ModalFooter)`
  height: 47px;
  padding: 0px;
  border: none;
  button {
    border: none;
    border-radius: 0px;
    height: 47px;
    width: 100%;
    background: ${colors.primary};
    font: 16px ${fonts.secondary};
    text-transform: uppercase;
    font-weight: 500;
    &:active,
    &:focus {
      outline: none;
      background: darken(${colors.primary}, 5%);
      border: none;
      box-shadow: none;
    }
  }
`;
